module.exports = __webpack_public_path__ + "static/media/CentroMedicoBazterica.d2a43ca1.svg";